module.exports = __webpack_public_path__ + "static/media/google.e3ea015c.svg";